import {Race} from '../models/race';

export function isRace(race: unknown): race is Race {
    return typeof race === 'object' && race !== null && 'token' in race && 'id' in race && 'state' in race;
}
